import React, { useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default function ImageMiniature({
    index,
    src,
    alt,
    onClick,
}: {
    index: number
    src: string
    alt: string
    onClick: (index: number) => void
}) {
    const [loaded, setLoaded] = useState(false)

    const handleImgLoaded = () => setTimeout(() => setLoaded(true), 200)

    return (
        <div className="group hover:cursor-pointer relative w-full aspect-square overflow-hidden">
            <div
                className={`w-full h-full absolute ${
                    loaded ? 'opacity-0' : 'opacity-100'
                } duration-500`}
            >
                <SkeletonTheme baseColor="#1c1917" highlightColor="#44403c">
                    <Skeleton className="w-full h-[110%] absolute -top-[10%]" />
                </SkeletonTheme>
            </div>

            <img
                src={src}
                alt={alt}
                className={`absolute w-full h-full group-hover:scale-105 duration-200 ${
                    loaded ? 'opacity-100' : 'opacity-0'
                } duration-500`}
                loading="lazy"
                onLoad={handleImgLoaded}
                onClick={() => onClick(index)}
            />
        </div>
    )
}
